"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EHereMapMarkerType = void 0;
// initial component state interface
// some configuration values needed to initialize the HereMap
// props expected by HereMaps Component
var EHereMapMarkerType;
exports.EHereMapMarkerType = EHereMapMarkerType;
(function (EHereMapMarkerType) {
  EHereMapMarkerType[EHereMapMarkerType["Default"] = 0] = "Default";
  EHereMapMarkerType[EHereMapMarkerType["Draggable"] = 1] = "Draggable";
  EHereMapMarkerType[EHereMapMarkerType["Dom"] = 2] = "Dom";
  EHereMapMarkerType[EHereMapMarkerType["DomDraggable"] = 3] = "DomDraggable";
})(EHereMapMarkerType || (exports.EHereMapMarkerType = EHereMapMarkerType = {}));